import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';
import { ImportSetsAdminListWire } from './types';
import { ImportSetsSearchModel } from './types-store';

export const api = {

  loadList: async (
    model: ImportSetsSearchModel, startIndex: number, maxResults: number
  ): Promise<ImportSetsAdminListWire> => {

    const response = await new RemoteAdminData(endpoints.searchImportSets)
      .resource<Response>()
      .filter({
        displayNotSelected: true,
        ...(startIndex !== undefined && { startIndex }),
        ...(maxResults !== undefined && { maxResults })
      })
      .create(model, false);

    const json = await response.json();

    return json.data;
  },

  deleteImportSet: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.deleteImportSetItem)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  }
};
